
import { getMaxIndex } from '@/utils/index';

export default {
  name: 'SlideView', // 客户管理详情 滑动view
  componentName: 'SlideView',
  components: {},
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    bodyStyle: {
      type: Object,
      default: function _default() {
        return { padding: 0 };
      }
    },
    /** 监听点击事件 隐藏视图 */
    listenerIDs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /** 阻挡点击事件 隐藏视图 */
    noListenerIDs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    noListenerClass: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      zIndex: getMaxIndex(),
      isEditClose: false,
      dialogVisible: false,
      targetData: {
        isMoveClick: false,
        pageX: 0,
        pageY: 0
      }
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    var _this = this;

    this.$on('setEditClose', function (value) {
      _this.isEditClose = value;
    });
  },
  mounted: function mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }

    document.getElementById('app').addEventListener('click', this.handleDocumentClick, false);
    document.getElementById('app').addEventListener('mousedown', this.handleDocumentMousedown, false);
    document.getElementById('app').addEventListener('mouseup', this.handleDocumentMouseup, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.dialogVisible = false;

    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    document.getElementById('app').removeEventListener('click', this.handleDocumentClick, false);
    document.getElementById('app').removeEventListener('mousedown', this.handleDocumentMousedown, false);
    document.getElementById('app').removeEventListener('mouseup', this.handleDocumentMouseup, false);
  },

  methods: {
    handleDocumentClick: function handleDocumentClick(e) {
      if (this.targetData.isMoveClick) {
        this.targetData.isMoveClick = false;
      } else {
        var hidden = true;
        this.noListenerIDs.forEach(function (element) {
          if (document.getElementById(element) && document.getElementById(element).contains(e.target)) {
            hidden = false;
          }
        });

        this.noListenerClass.forEach(function (element) {
          var items = document.getElementsByClassName(element);
          if (items && hidden) {
            for (var index = 0; index < items.length; index++) {
              var _element = items[index];
              if (_element.contains(e.target)) {
                hidden = false;
                break;
              }
            }
          }
        });

        if (document.getElementById('slide') && document.getElementById('slide').contains(e.target)) {
          hidden = false;
        }
        if (hidden) {
          this.close();
        }
      }
    },
    handleDocumentMousedown: function handleDocumentMousedown(e) {
      this.targetData.pageX = e.pageX;
      this.targetData.pageY = e.pageY;
    },
    handleDocumentMouseup: function handleDocumentMouseup(e) {
      if (Math.abs(this.targetData.pageX - e.pageX) > 30 || Math.abs(this.targetData.pageY - e.pageY) > 30) {
        this.targetData.isMoveClick = true;
      } else {
        this.targetData.isMoveClick = false;
      }
    },
    afterEnter: function afterEnter() {
      this.$emit('afterEnter');
    },
    close: function close() {
      if (this.isEditClose) {
        this.dialogVisible = true;
      } else {
        this.$emit('close');
      }
    },
    dialogSure: function dialogSure() {
      this.dialogVisible = false;
      this.$emit('close');
    }
  }
};